<template>
  <div
    id="idModalFtp"
    class="modal-company-drive"
  >
    <div class="wrap-content">
      <button @click="$emit('close-popup', null)">close</button>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import apiThirdParty from '@/services/jApiThirdParty';

export default {
  props: {
    thirdParty: {
      type: Object,
      default: () => {},
    },
  },

  mounted() {
    this.getListDirectory();
  },

  methods: {
    async getListDirectory() {
      const param = {
        host: this.thirdParty.host,
        port: this.thirdParty.port,
        username: this.thirdParty.username,
        password: this.thirdParty.password,
        path: this.thirdParty.path,
      };
      const res = await apiThirdParty.getListDirectoryFtp(param);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/popup/ModalFtp.vue